export { 
  AggregatePlzArray, 
  GetDisplayValueOfPath,
  BuildTreeFromPlzPaths
}

//Removes Plz of Lower Level if entrie Upper Level is selected (If All districts in Canton are selected, only return Canton itself)
function AggregatePlzArray(plzsToAggregate, fullPlzTree){
  let aggregatedPlz = [];

  let cantonsOfCountry = [];
  let countryIsComplete = true;
  fullPlzTree[0].children.map(canton => {

    let districtsOfCantons = [];
    let cantonIsComplete = true;
    canton.children.map(district => {

      let plzOfDistrict = plzsToAggregate.find(plz => plz.path === district.path);
      let citiesOfDistrict = [];
      let districtIsComplete = true;
      district.children.map(city => {
        let plzOfCity = plzsToAggregate.find(plz => plz.path === city.path);
        if(plzOfCity){
          citiesOfDistrict.push(plzOfCity);
        }
        else{
          districtIsComplete = false;
        }
      });

      if(!districtIsComplete){
        aggregatedPlz.push(...citiesOfDistrict);
      }

      if(plzOfDistrict){
        districtsOfCantons.push(plzOfDistrict);
      }
      else{
        cantonIsComplete = false;
      }

    });

    if(!cantonIsComplete){
      aggregatedPlz.push(...districtsOfCantons);
    }

    let plzOfCanton = plzsToAggregate.find(plz => plz.path === canton.path);
    if(plzOfCanton){
      cantonsOfCountry.push(plzOfCanton);
    }
    else{
      countryIsComplete = false;
    }

  });

  if(!countryIsComplete){
    aggregatedPlz.push(...cantonsOfCountry);
  }
  else{
    let plzOfContry = plzsToAggregate.find(plz => plz.path === "CH");
    aggregatedPlz.push(plzOfContry);
  }

  return aggregatedPlz;
}

function GetDisplayValueOfPath(path, cititesData){
  let label = "Ganze Schweiz";
  var allCities = cititesData;
  let pathPieces = path.split("/");
  
  if(pathPieces.length == 2){
    let cantonOfPiece = allCities.find(x => x.cantonCode == pathPieces[1]);
    label = cantonOfPiece ? `${cantonOfPiece.canton} (${cantonOfPiece.cantonCode})` : label;
    return label;
  }
  if(pathPieces.length == 3){
    let districtOfPiece = allCities.find(x => x.districtCode == pathPieces[2]);
    label = districtOfPiece ? `${districtOfPiece.district} (${districtOfPiece.cantonCode})` : label;
    return label;
  }
  if(pathPieces.length == 4){
    let cityOfPiece = allCities.find(x => x.onrp == pathPieces[3]);
    label = cityOfPiece ? `${cityOfPiece.plz} ${cityOfPiece.city}` : label;
    return label;
  }

  return label;
}

function BuildTreeFromPlzPaths(paths){
  let tree = {
    path: "CH",
    numberOfChildren: 0
  };
  for (let i = 0; i < paths.length; i++) {
    const path = paths[i];
    let pathPieces = path.split("/");
    let canton = pathPieces[1];
    let district = pathPieces[2];
    let city = pathPieces[3];

    if(!canton){
      continue;
    }
    let cantonNode = tree[canton];
    if(canton && !cantonNode){
      cantonNode = {
        path: `CH/${canton}`,
        numberOfChildren: 0
      }
      tree[canton] = cantonNode;
      tree.numberOfChildren = tree.numberOfChildren + 1;
    }

    if(!district){
      continue;
    }
    let districtNode = cantonNode[district];
    if(district && !districtNode){
      districtNode = {
        path: `CH/${canton}/${district}`,
        numberOfChildren: 0
      }
      cantonNode[district] = districtNode;
      cantonNode.numberOfChildren = cantonNode.numberOfChildren + 1;
    }

    if(!city){
      continue;
    }
    let cityNode = districtNode[city];  
    if(city && !cityNode){
      cityNode = {
        path: `CH/${canton}/${district}/${city}`,
        numberOfChildren: 0
      }
      districtNode[city] = cityNode;
      districtNode.numberOfChildren = districtNode.numberOfChildren + 1;
    }
  }

  return tree;
}